import { render, staticRenderFns } from "./SnsPostForm.vue?vue&type=template&id=0c61c6d8&"
import script from "./SnsPostForm.vue?vue&type=script&lang=js&"
export * from "./SnsPostForm.vue?vue&type=script&lang=js&"
import style0 from "./SnsPostForm.vue?vue&type=style&index=0&id=0c61c6d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports